var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "registration-form--inner" }, [
    _c("h3", { staticClass: "registration-form-layout__block-title" }, [
      _vm._v(
        _vm._s(_vm.locales && _vm.locales.users && _vm.locales.users.person) +
          " " +
          _vm._s(_vm.i + 1)
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "grid grid-cols-1 gap-x-4 gap-y-4 sm:grid-cols-2 md:gap-y-6"
      },
      [
        _c("theme-input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "`required`"
            }
          ],
          attrs: {
            label: _vm.usersFirstName,
            name: "person[" + [_vm.i] + "][first_name]",
            placeholder: _vm.usersFirstNamePlaceholder,
            isRequired: true
          }
        }),
        _vm._v(" "),
        _c("theme-input", {
          attrs: {
            label: _vm.usersMiddleName,
            name: "person[" + [_vm.i] + "][middle_name]",
            placeholder: _vm.usersMiddleNamePlaceholder,
            isRequired: true
          }
        }),
        _vm._v(" "),
        _c("theme-input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "`required`"
            }
          ],
          attrs: {
            label: _vm.usersLastName,
            name: "person[" + [_vm.i] + "][last_name]",
            placeholder: _vm.usersLastNamePlaceholder,
            isRequired: true
          }
        }),
        _vm._v(" "),
        _c("theme-calendar", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "`required`"
            }
          ],
          attrs: {
            label: _vm.usersDateOfBirth,
            name: "person[" + [_vm.i] + "][birthdate]",
            placeholder: _vm.usersDateOfBirthPlaceholder,
            isRequired: true
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("theme-input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|phone_number",
              expression: "`required|phone_number`"
            }
          ],
          staticClass: "js-unique-phone",
          attrs: {
            label: _vm.usersPhoneNumber,
            name: "person[" + [_vm.i] + "][phone_number]",
            placeholder: _vm.usersPhoneNumberPlaceholder,
            isRequired: true
          }
        }),
        _vm._v(" "),
        !!_vm.is_phone_number_unique
          ? _c("div", { staticClass: "mt-2" }, [
              _c("span", { staticClass: "text-[#FF695B] text-[12px]" }, [
                _vm._v(_vm._s(_vm.phoneNumberAlreadyExists))
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "`required`"
                  }
                ],
                attrs: { type: "hidden", name: "phone_number_unique" }
              })
            ])
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("theme-input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|email",
              expression: "`required|email`"
            }
          ],
          staticClass: "js-unique-mail",
          attrs: {
            label: _vm.usersEmail,
            name: "person[" + [_vm.i] + "][email]",
            placeholder: _vm.usersEmailPlaceholder,
            isRequired: true
          },
          on: { blur: _vm.checkMail }
        }),
        _vm._v(" "),
        _vm.is_user_already_exists == 1
          ? _c("div", { staticClass: "mt-2" }, [
              _c("span", { staticClass: "text-[#FF695B] text-[12px]" }, [
                _vm._v(_vm._s(_vm.isUserAlreadyExists))
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "`required`"
                  }
                ],
                attrs: { type: "hidden", name: "user_already_exists" }
              })
            ])
          : _vm.is_user_already_exists == 2
          ? _c("div", { staticClass: "mt-2" }, [
              _c("span", { staticClass: "text-[#FF695B] text-[12px]" }, [
                _vm._v(_vm._s(_vm.isUserBanned))
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "`required`"
                  }
                ],
                attrs: { type: "hidden", name: "user_already_exists" }
              })
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f0f27cb4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0f27cb4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/RegistrationInnerForm.vue
// module id = 659
// module chunks = 1